// @flow
import type { Errors } from 'types/errors';
import type { PassengerLibraryState } from 'reducers/library';
import type { Passenger } from 'types/entities';
import type { RequestStates } from 'types/redux';

import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';
import { PASSENGER_BEHAVIOURS_NAMES } from 'utils/library-utils';

import withEscapeToDismiss from 'components/others/WithEscapeToDismiss';
import ErrorNotification from 'components/others/ErrorNotification';

type Props = {
  activeCohortID: string,
  passengers: PassengerLibraryState,
  cohortPassengerAssociate: Function,
  cohortPassengerAssociateRequest: RequestStates,
  cohortPassengerAssociateErrors: Errors,

  handleClose: Function,
  isPassengersModalActive: boolean,

  resetErrorState: Function,
};

@withEscapeToDismiss()
export default class PassengersModal extends Component {
  componentDidMount() {
    this.props.resetErrorState('cohortPassengerAssociate');
  }

  props: Props;

  render() {
    return (
      <div
        className={classnames('modal', {
          'is-active': this.props.isPassengersModalActive,
        })}
        role="dialog"
      >
        <div
          className="modal-background" onClick={() => {
            this.props.handleClose();
          }}
        />
        <div className="modal-content">
          <div className="modal-box">
            <button
              aria-label="Close"
              className="is-pulled-right delete"
              onClick={() => {
                this.props.handleClose();
              }}
            />
            <h3 className="title is-5">Associate Passengers</h3>
            <table className="table is-bordered is-striped">
              <thead>
                <tr>
                  <th>Gamma ID</th>
                  <th>Name</th>
                  <th>Behaviour</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(this.props.passengers).map((cohortPassengerID: string) => {
                  const passenger: Passenger = this.props.passengers[cohortPassengerID];
                  return (
                    <tr key={cohortPassengerID}>
                      <td>{cohortPassengerID}</td>
                      <td>{passenger.name || '-'}</td>
                      <td>{PASSENGER_BEHAVIOURS_NAMES[_.get(passenger, 'behaviour.type')]}</td>
                      <td>
                        <div className="control is-grouped">
                          <p className="control">
                            <button
                              className={classnames('button is-small is-outlined is-info', {
                                'is-disabled': this.props.cohortPassengerAssociateRequest.isPending,
                              })}
                              onClick={() => {
                                this.props.cohortPassengerAssociate(this.props.activeCohortID,
                                  _.cloneDeep(passenger));
                              }}
                            >
                              Associate
                            </button>
                          </p>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {_.isEmpty(this.props.passengers) && <tr>
                  <td colSpan={999} className="has-text-centered">No passengers added.</td>
                </tr>}
              </tbody>
            </table>
            {!_.isEmpty(this.props.cohortPassengerAssociateErrors) &&
              <ErrorNotification errors={this.props.cohortPassengerAssociateErrors} />
            }
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/passengers/PassengersModal.jsx
 **/